import { render, staticRenderFns } from "./ConnectFail.vue?vue&type=template&id=214237fe&scoped=true&"
import script from "./ConnectFail.vue?vue&type=script&lang=js&"
export * from "./ConnectFail.vue?vue&type=script&lang=js&"
import style0 from "./ConnectFail.vue?vue&type=style&index=0&id=214237fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214237fe",
  null
  
)

export default component.exports